var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElephant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.411,
    height: 19.246,
    viewBox: "0 0 11.411 19.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M111.061,5.541a.37.37,0,0,1-.3.1c-.6.3-1.31.5-2.015.907a3.619,3.619,0,0,0-1.008.705,5.672,5.672,0,0,0-1.713,2.62,5.479,5.479,0,0,0,0,1.814,2.988,2.988,0,0,0,.705,1.511h0a1.158,1.158,0,0,0,.907.6c.4.1.806-.2,1.108-.4a1.625,1.625,0,0,1,.907-.3.835.835,0,0,0,.806-.3,1.144,1.144,0,0,0,.3-.806,3.563,3.563,0,0,1,.6-.1v.6c0,.2-.1.4-.1.6a1.217,1.217,0,0,1-.705.705c-.3.1-.6,0-1.008.1a3.58,3.58,0,0,0-.907.4,1.663,1.663,0,0,1-1.914-.1,3.711,3.711,0,0,1-1.108-1.914l-.1-.2-.3.2a.1.1,0,0,0-.1.1,6.326,6.326,0,0,0-1.209,1.108,4.629,4.629,0,0,0-.705,1.612,1.278,1.278,0,0,0-.1.6,21.827,21.827,0,0,0-.1,3.627h3.426v-.4a1.652,1.652,0,1,1,3.224,0v.4h3.527a8.157,8.157,0,0,1-.1-3.124,14.73,14.73,0,0,1,.5-2.015,11.52,11.52,0,0,0,.705-3.224,22.779,22.779,0,0,0,.1-2.62c0-.4-.1-.907-.1-1.31v-.1A7.945,7.945,0,0,0,106.325.1l-.2.6s5.643,0,5.34,4.736c-.2,0-.3.1-.4.1m-.4,2.821h0a.65.65,0,0,1-.6-.6.6.6,0,1,1,1.209,0A.65.65,0,0,1,110.658,8.362Z",
    transform: "translate(-102.975 -0.099)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElephant);
export default __webpack_public_path__ + "static/media/elephant.4a04f56a.svg";
export { ForwardRef as ReactComponent };